// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarPeriodicidadeEstatisticaVolatilidade,
  getPeriodicidadeEstatisticaVolatilidadeSelecionada,
  getPeriodicidadeEstatistica,
} from "../../../../state";

export default function SelecaoPeriodicidadeEstatisticaVolatilidade() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"Periodicidade.Descricao"}
        itensSelector={getPeriodicidadeEstatistica}
        selectorItemSelecionado={
          getPeriodicidadeEstatisticaVolatilidadeSelecionada
        }
        onItemChange={selecionarPeriodicidadeEstatisticaVolatilidade}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
        radioName="periodicidadeEstatisticaVolatilidade"
      />
    </div>
  );
}
